module.exports = __webpack_public_path__ + "img/pmx.8d1b9bb4.jpg";